import { useTranslation } from "react-i18next";

const PARTNERS = [
  {
    name: "Tibika",
    href: "https://beta.tibika.com",
    initials: "T",
    color: "#009640",
  },
  {
    name: "RxPoa",
    href: "https://rxpoa.com",
    initials: "R",
    color: "#1a53a1",
  },
  {
    name: "Medsoko",
    href: "https://medsoko.com",
    initials: "M",
    color: "#007ac1",
  },
];

export const PartnersRow = ({ dark = false }: { dark?: boolean }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-start gap-2">
      <span
        className={`text-xs uppercase tracking-wider ${
          dark ? "text-secondary-400" : "text-secondary-500"
        }`}
      >
        {t("partners")}
      </span>
      <div
        className={`flex items-center gap-6 ${
          dark ? "opacity-90" : "opacity-80"
        }`}
      >
        {PARTNERS.map((partner) => (
          <a
            key={partner.name}
            href={partner.href}
            target="_blank"
            rel="noreferrer"
            aria-label={partner.name}
            className={`flex items-center gap-2 font-semibold hover:underline ${
              dark ? "text-white" : "text-secondary-900"
            }`}
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              aria-hidden="true"
              className="shrink-0"
            >
              <circle cx="14" cy="14" r="14" fill={partner.color} />
              <text
                x="14"
                y="18.5"
                textAnchor="middle"
                fontSize="13"
                fontWeight="700"
                fill="#ffffff"
                fontFamily="sans-serif"
              >
                {partner.initials}
              </text>
            </svg>
            {partner.name}
          </a>
        ))}
      </div>
    </div>
  );
};
